import { connect } from 'react-redux';
//
import DealDetails from 'components/sidebar/deal-management/deal-details/deal-details';
import { IStoreState } from 'store';
import { updateDealField } from 'store/deal-edit/actions';

const mapStateToProps = ({ dealEdit, fieldOptions }: IStoreState) => ({
  dealEdit,
  fieldOptions,
});

const mapDispatchToProps = {
  updateDealField,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealDetails);
